import React from 'react';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { compose } from 'ramda';

import { Grid } from '_utils/components/Corporate';
import { Container, Description } from './StyledPageIntro';
import { withEditMode, withEditModeNotice } from '_containers/BaseComponent';
import { BackgroundColors } from '_utils/components/Corporate/Section';
import PropTypes from 'prop-types';

const EditorText = compose(withEditModeNotice)(Text);

export const PageIntro = (props) => {
  const { sitecoreContext, editMode, params } = props;

  const components = sitecoreContext?.route?.placeholders['jss-main'];

  let pageIntroComponents = components.filter((component) => component.componentName === 'PageIntro');

  const hasGalleryComponent = components
    .filter((component) => component.componentName === 'Gallery')[0]
    ?.fields?.data?.datasource?.gallery?.some((i) => i?.item?.data?.value?.src);

  if (pageIntroComponents.length === 0) {
    return null;
  }

  // Default
  let backgroundColor = BackgroundColors.Grey;

  try {
    backgroundColor = BackgroundColors[params.backgroundColour];
  } catch {}

  const pageDescription =
    pageIntroComponents[0]?.fields?.data?.pageFields?.pageDescription?.jss || {};
  let description = pageDescription.value || null;

  let editorNotice = null;

  if (editMode && !pageIntroComponents[0]?.fields?.data?.pageFields?.pageDescription) {
    editorNotice = 'PageIntro has no data source';
  }

  if (editMode && !description) {
    editorNotice = 'Page has no description';
  } else if (editMode && description) {
    editorNotice = 'Overrides page description';
  }

  if (editMode) {
    return (
      <Container
        className={backgroundColor}
        $sectionTheme={backgroundColor}
        $hasPaddingTop={!hasGalleryComponent}
      >
        <Grid.Container>
          <Description>
            <EditorText
              field={pageDescription}
              noticeEnabled={false}
              noticeLevel="info"
              noticeMessage={editorNotice}
            />
          </Description>
        </Grid.Container>
      </Container>
    );
  } else {
    return (
      <>
        {description && (
          <Container
            className={backgroundColor}
            $sectionTheme={backgroundColor}
            $hasPaddingTop={!hasGalleryComponent}
          >
            <Grid.Container>
              <Description>
                <Text field={{ value: description }} />
              </Description>
            </Grid.Container>
          </Container>
        )}
      </>
    );
  }
};

PageIntro.propTypes = {
  sitecoreContext: PropTypes.shape({
    route: PropTypes.shape({
      placeholders: PropTypes.shape({
        'jss-main': PropTypes.arrayOf(PropTypes.object)
      })
    })
  }),
  editMode: PropTypes.bool,
  params: PropTypes.shape({
    backgroundColour: PropTypes.string
  })
};

export default compose(withSitecoreContext(), withEditMode, withEditModeNotice)(PageIntro);
